import Signup from './Signup';

const ACTION = {
  ...Signup.ACTION,
};

const ACTION_TYPES = {
  ...Signup.ACTION_TYPES,
};

const signup = {
  ACTION,
  ACTION_TYPES
}

export default signup;